import { render, staticRenderFns } from "./mygroup.vue?vue&type=template&id=e745284e&scoped=true"
import script from "./mygroup.vue?vue&type=script&lang=js"
export * from "./mygroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e745284e",
  null
  
)

export default component.exports